module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chNo"
  }, [_vm._v("Embroidery Essentials")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("EMBROIDERY IS ONE OF THE EASIEST CRAFTS TO LEARN AND REQUIRES ONLY A FEW SIMPLE TOOLS THAT ARE EASY TO FIND. BEFORE YOU START EMBROIDERING, YOU’LL NEED TO TRACK DOWN A FEW BASIC ITEMS AND LEARN SOME EASY STITCHES AND TECHNIQUES.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "c1"
    }
  }, [_vm._v("MATERIALS AND TOOLS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("You can start stitching with just some fabric, floss, an embroidery needle, and a hoop, but you might find it useful to have additional items on hand. Plus, there will be certain tools you’ll need to complete several of the projects in this book. All the materials and tools are relatively inexpensive, and chances are good that you already have some of them on hand. If not, you can find them all at your local craft store.")]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg8_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("Embroidery Toolbox")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bb"
  }, [_vm._v("•")]), _vm._v("Embroidery hoop (check the individual project instructions for suggested sizes)")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bb"
  }, [_vm._v("•")]), _vm._v("Embroidery and sewing needles")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bb"
  }, [_vm._v("•")]), _vm._v("Embroidery floss")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bb"
  }, [_vm._v("•")]), _vm._v("Fabric stabilizer")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bb"
  }, [_vm._v("•")]), _vm._v("Iron")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bb"
  }, [_vm._v("•")]), _vm._v("Ironing board or towel")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bb"
  }, [_vm._v("•")]), _vm._v("Needle threader")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bb"
  }, [_vm._v("•")]), _vm._v("Nonpermanent fabric marker")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bb"
  }, [_vm._v("•")]), _vm._v("Pencil")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bb"
  }, [_vm._v("•")]), _vm._v("Pincushion")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bb"
  }, [_vm._v("•")]), _vm._v("Ruler")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bb"
  }, [_vm._v("•")]), _vm._v("Scissors")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bb"
  }, [_vm._v("•")]), _vm._v("Straight pins")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bb"
  }, [_vm._v("•")]), _vm._v("Thimble")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bb"
  }, [_vm._v("•")]), _vm._v("Tracing and transferring tools (such as dressmaker’s carbon paper)")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bb"
  }, [_vm._v("•")]), _vm._v("Tweezers")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("Fabrics and Other Materials")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The most common fabrics used for embroi­dery are quilting cotton, linen made for handwork, and Aida cloth (a heavy fabric with a large, even weave). However, almost any fabric is suitable for embroidery. Here’s my general rule: If you can stick a needle through it, you can embroider it. (That includes vinyl, heavy paper, balsa wood, and many other unconventional materials!) For the projects in this book, I mostly used quilting cotton, linen, and canvas.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Delicate materials such as chiffon, silk and sheer fabrics may require an extra bit of care when you secure them on a hoop so that you don’t distort or stretch the weave. Fine fabrics and stretchy fabrics like cotton T-shirts usually behave better if you apply removable fabric stabilizer (see Stabilizer) before you start stitching. Craft felt is a sturdy fabric that can easily handle hand stitching and gener­ally won’t pucker when embroidered. You may not always need a hoop when stitching on felt, especially if you’re using small pieces. Felt is also perfect for finishing up the backs of your finished embroidery hoop art. Transparent stitchable mesh will give you unique results when used for embroidery and is fun to experiment with. If you’re just starting to embroider and need some fabric, take a look at your wardrobe or linen closet. You never know what inspiration you might find.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("Floss")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("You can embroider with just about any thread, but the most common type used is embroidery floss. Floss is sold in a small bundle, or skein and comes in any color you want. Most floss is made from cotton, but if you’re feeling adventurous, look for specialty flosses made of linen, metallic, silk, or wool strands to add a special touch to your stitching.")]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg9_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A length of floss is made up of 6 threads that are twisted together. You can use all 6 to stitch a thick line or divide them up and use a smaller number for thinner lines and fine details. Check the instructions for each project to see what number of threads is suggested. Typically, 3 threads is a good quantity. However, you may want to stitch small interior details with fewer threads and main outlines with more threads. Varying the number of threads on your project is one way to add dimension to your work.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Every skein of embroidery floss comes wrapped in paper with a different number for each color. Each floss manufacturer has its own unique numbering system for their colors. For each project in this book, you’ll find numbers for DMC embroidery floss. It’s easy to find conversion charts if you switch between brands. Check with specialty shops or search the Internet for “embroidery floss conversion chart.” When you’re starting a project, it’s a good idea to jot down the numbers you’re using in case you need to get more floss later.")]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg10_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The more embroidery projects you make, the more floss you’ll accumulate. You might find it useful to organize the floss by wrapping each color on a plastic or cardboard bobbin. Write the color number on the bobbins and then store them together in a box. You can buy special sectioned containers at craft stores, but ordinary fishing tackle boxes also work great.")]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_c('span', {
    staticClass: "tt"
  }, [_vm._v("TIP")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentd"
  }, [_vm._v("Don’t toss all those pretty bits of scrap floss when you’re done stitching, save them up in a glass jar! You can use them for artwork too (see Scrap Floss Art).")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("Needles")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A good embroidery needle is medium-sized (size 5 is my favorite) and has a sharp point and long opening, or eye, at one end. Larger needles are helpful when you’re using all 6 threads of floss, and small ones are ideal for hand stitching with a single thread. You can purchase a pack of several different sizes so you have any size you need on hand.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("Embroidery Hoops")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("An embroidery hoop is a 2-piece frame with an inner and outer circle. The circles fit together and keep your fabric taut as you work, giving you a tight, smooth surface to stitch on. A 6˝ (15.2 cm) plastic or wooden hoop is a good standard size that you can reuse over and over. Small designs will fit inside the circle, and for larger designs, you can move the hoop around as needed.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Many of the projects in this book call for a wooden embroidery hoop, which will become a perma­nent frame for your artwork when you’re finished stitching and can be hung right on the wall. Wooden hoops are inexpensive and come in lots of sizes to fit any project. You can use one to hold your fabric as you embroider and then decorate your hoop (see Hoop Framing). Mini hoop frames, 1˝–2˝ (2.5–5.1 cm) diameter, are fun for displaying very small motifs. You’ll first need a larger hoop for embroidering and then put the designs into the smaller hoops for display.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("Scissors and Pinking Shears")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Keep a pair of small, sharp sewing scissors on hand while embroidering. You’ll need them to cut lengths of floss and snip any leftover floss when you’re finished stitching. Pinking shears are used to trim inside out edges of any pillow or toy that will then be turned right side out and stuffed. You can also use them to cut decorative edges on appliqué pieces.")]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg11_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("Nonpermanent Fabric Markers")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Nonpermanent fabric markers are great for tracing your patterns onto fabric and come in several varieties. Some make marks that wash away with water, while others make marks that simply fade over time. If you choose a pen with disappearing or air-soluble ink, make sure you avoid using it for a project that you’ll be working on for several days or your pattern may fade before you’ve finished stitching.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("Ribbon")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Ribbon makes the perfect finishing touch for your embroidery hoop art. You can wrap the outer hoop, see Ribbon Wrapping or make a bow or loop that you can use to hang your hoop. Choose a variety that complements your design: satin, grosgrain, sheer, or sparkly. Use ½˝- or "), _c('sup', [_vm._v("⅝")]), _vm._v("˝- (1.3 or 1.6 cm) wide ribbon for wrapping a hoop, ¾˝–1˝ (1.9–2.5 cm) wide for a big bow or loop.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("Polyester Fiberfill")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Polyester fiberfill (commonly used as stuffing) is what most pillows and soft toys are filled with. When you stuff an item, use small amounts of fiberfill at a time, poking it into corners and small areas first. A knitting needle or chopstick can come in handy here. Then stuff the remaining space firmly before stitching up the opening.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("Stabilizer")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When embroidering on stretchy or delicate fabrics such as T-shirt cotton or silk, you will want to apply a fabric stabilizer. Stabilizer comes in many varieties. The kind I use most often has an adhesive back and dissolves in water. such as Wash-Away Stitch Stabilizer (by C&T Publishing). You can cut a piece to whatever size you need, stick it to the back of your fabric, then stitch through stabilizer and fabric together. After you’re done, just rinse away the stabilizer.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("Other Useful Tools")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Pins and a small pincushion are always good to have on hand when working on sewing projects. You can make a simple pincushion pillow by hand sewing 2 small pieces of felt with a little stuffing inside. Try embellishing it with a bit of embroidery!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If you have trouble threading your needle, a needle threader will make the job quick and easy.")]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg11_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("You’ll be glad to have a thimble on your finger when pushing the needle through tough fabrics like canvas. A leather or rubber thimble will protect your fingers and also help you get a good grip on the needle.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "c2"
    }
  }, [_vm._v("TRANSFERRING PATTERNS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There are several methods for transferring your embroidery pattern to fabric. Different methods work better for different types of fabrics. Start by tracing the design from this book onto tracing paper or making a photocopy. You can combine different motifs, or add your own writing or embellishments to make your pattern unique. Once you have your design ready, choose one of the transfer methods below.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("Light Method")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The easiest way to transfer a design onto a light-colored fabric is to trace it using a light table or sunny window. Tape the design to the light source, place your fabric over it, and then trace the design with a pencil or a nonpermanent fabric marker.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If you’re using pencil, the lines may not wash completely out of the fabric when you’re done, so just be sure to cover the lines completely with stitching.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Marks from some transfer tools become permanent when ironed, so be sure to test your tools on a scrap of fabric before you use them!")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("Carbon Paper Method")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("For this method, you’ll need dressmaker’s carbon paper, which can be purchased at most fabric and craft stores. It comes in a variety of colors to contrast with the color of your fabrics. Place your fabric on a hard surface, set a piece of carbon paper facedown on top of it, and your pattern on top of that. Trace over the pattern with a ballpoint pen, pencil, or other blunt tool like a knitting needle or chopstick. The chalky marks from the transfer paper sometimes will fade as you work. If you notice the pattern wearing off, go over the lines with a fabric marker or chalk pencil. I use this method mostly for darker colored fabrics that marker lines don’t show up on.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("Iron-On Transfers")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("You can make your own iron-on transfers with a black-and-white laser print or photocopier (ink-jet prints won’t work). Remember that you’ll need to reverse the image before printing or it will be backward when you apply it to your fabric. Simply place the print facedown on your fabric and iron it to transfer the image. You can reuse your iron-on print several times. The lines will be permanent, though they may fade over time, so you’ll need to completely cover them with embroidery. Homemade iron-on transfers can vary greatly depending on the type of paper, ink, and fabric you’re using, so you may need to experiment with this method a bit before using it for your project.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("Tissue Paper Method")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("You can trace your pattern onto tissue or tracing paper, pin the paper onto your fabric, and stitch right through the paper and fabric together. When you’re done, gently tear away the paper, using tweezers to remove the bits under your stitches. This method works well for thick fabrics, especially felt, which can be tricky to transfer onto any other way.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("Fabric Stabilizer Method")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Water-soluble fabric stabilizer can be used in the same way as the tissue paper method just described. The stabilizer will dissolve away in water when you’re finished stitching. My favorite type of stabilizer has adhesive backing that sticks right to your fabric, and you can print on it with a desktop printer so it’s easy to create a customized pattern for stitching, no tracing required, such as Wash-Away Stitch Stabilizer (by C&T Publishing).")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "c3"
    }
  }, [_vm._v("GET STITCHING!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("After you’ve gathered all of your materials, you’ll need to follow a few easy steps to prepare them, and then you’ll be ready to begin stitching.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("Preparing the Fabric")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Begin by washing and ironing the fabric. If you’re using a stretchy, flimsy, or loose-weave fabric, you may find it easier to work with if you first apply a fabric stabilizer to the back. A stabilizer keeps fabric from stretching while you work and creates a smooth surface for stitching.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There are many types of stabilizers for different types of fabrics. You’ll apply a piece to the back of your fabric, stitch through both the fabric and stabilizer, and then remove the stabilizer when you’re done. Some will need to be carefully torn and separated from the fabric with the help of tweezers to remove the pieces behind the stitches, while others dissolve in water.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("Preparing the Hoop and Floss")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Secure your fabric onto a hoop by spreading it over the smaller inside hoop and fit the larger outside one over the top with your fabric in between. Tighten the little screw on the outer hoop and gently pull out on all the edges of the fabric until you have a tight, smooth surface.")]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg13_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Now thread the needle. Start with a length of floss 12˝–18˝ (30.5–45.7 cm) long. If you have trouble, dampen your finger and twist the end of the floss to a point or squeeze the end flat between your thumb and forefinger. Try sliding the needle’s eye onto the floss (instead of pushing the floss through the needle). If all else fails, use a needle threader—it’ll save you a lot of headaches!")]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg14_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("After you’ve inserted the floss through the needle, knot the other end. One way to tie a knot is to wrap the floss around the end of your finger, roll it off, and pull downward to tighten it.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "c4"
    }
  }, [_vm._v("EMBROIDERING THE DESIGN")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Starting at the back of the fabric, bring the needle up and pull the needle and floss through until the knot catches. The floss may twist up after a while of stitching. If this happens, hold up the hoop and let the needle and floss hang straight down loose so that the strand can untwist. Be careful—don’t lose your needle!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When you’re down to a 2˝–3˝ (5.1–7.6 cm) length of floss, pull the strand through to the back of the fabric. Pass the needle under a stitch, bring the needle back through the floss loop, and tighten. Snip off the loose end near the knot.")]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg14_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("You can work on your embroidery section by section, completing each area before moving on to the next, or stitch a single color throughout the design before moving on to the next color.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "c5"
    }
  }, [_vm._v("FINISHING UP")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When you’ve finished your embroidery, remove the fabric from the hoop and remove any erasable transfer lines, tissue paper, or stabilizer. You can rinse it with water or hand-wash it with a gentle detergent. Press the water out by spreading the fabric flat and rolling it between 2 towels. When it’s almost dry, iron it face down on a towel. This will remove any wrinkles without crushing your stitches.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("The Back")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I don’t usually pay much attention to the backs of my embroidery projects, but there are a few tips to keep in mind if you’re stitching something where the back is visible, or on light-colored fabrics where messy knots or tails can show through the fabric. To keep the backs of your embroidery tidy, tie knots tightly and close to the fabric, and snip off any extra floss right above the knot. Tie off your floss with each section of the design and start with a new knot at the next point, rather than carrying the floss from point to point. Try not to carry floss longer than ½˝ (1.3 cm); this reduces the “spiderweb” effect on the back.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("Hoop Framing")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("After you finish many of the projects in this book, you’ll frame and hang them in the same wooden hoop that you used for embroidering. Here are a few techniques for finishing your hoops for framing.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("GLUING METHOD")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("After you finish your embroidery, secure the fabric onto the hoop, making sure the design is centered and the surface of the fabric is taut and smooth. Tighten the screw and then trim the fabric until it is about 1˝ (2.5 cm) from the edge. Next, run a line of white craft glue or hot glue around the inside of the inner hoop and fold the edge of the fabric over it. When the glue is dry, you can remove and decorate the outer hoop (see the methods).")]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg15_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("GATHERING METHOD")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The glue back method is quick and easy, but if you prefer a more traditional, stitched technique, try the Gathering Method. Secure the embroidered fabric onto the hoop, making sure the design is centered and the surface of the fabric is taut and smooth. Tighten the screw and then trim the fabric until it is about 1½˝ (3.8 cm) from the edge. Make a continuous running stitch around the edge of the fabric, pulling tightly toward the center of the back of the hoop. Tie a knot to secure the fabric in place. You can remove the outer hoop to decorate it.")]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg16_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg16_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("SEWING ON A BACKING")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("You can leave the back of your embroidery exposed in the hoop or cover it with another piece of fabric using one of the following methods. One way to make a backing is to trace the inside of the inner hoop circle onto a piece of white felt. Cut out the circle, and fit the felt circle into the back of the hoop. Secure it with a bit of craft glue. Alternatively, cut a second piece of fabric the same size as your embroidered fabric, place the plain piece of fabric behind the embroidered piece and secure the 2 together in the hoop. When you are ready to fold the fabric edges over the back, trim off the interior fabric right at the edge of the hoop and fold the outer embroidered fabric over it. These 2 methods need to be completed before you use the Gluing Method or Gathering Method to finish the piece.")]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg17_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If you are using the Gathering Method, you can add a piece of felt to cover the entire back of the hoop. Trace the outside of an inner hoop onto a piece of felt. Cut the felt circle out and place it over the back after you’ve gathered and knotted the edges of the embroidered fabric. Using the whipstitch, stitch the edge of the felt to the gathered fabric.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("RIBBON WRAPPING")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Though the look of the raw wood in your embroidery hoop may suit some designs, you may want to hide it in others. Ribbon wrapping is a beautiful way to cover the outer embroidery hoop. Choose a colored or textured ribbon that matches the embroidery. Remove the outer hoop and apply a thin line of white craft glue or hot glue around the inside. Starting at the screw, secure one end of the ribbon on the inside by pressing it into the glue. You can hold it in place with a clothespin if needed. Wrap it around the hoop at a diagonal angle, pulling tightly. Hold the ribbon flat to the hoop on the inside and outside as you go so it doesn’t bunch or fold. When you reach the other end of the hoop, wrap the ribbon an extra time around the end to hide it. It helps to unwind about 12˝ (30.5 cm) of ribbon from the roll before you start and put a pin in the roll to keep it from unwinding further. This will save you the headache of a long mess of ribbon getting in your way. Plus, if the ribbon gets twisted, you can just let it dangle to unravel it. Choose ribbons that are ½˝ or "), _c('sup', [_vm._v("⅝")]), _vm._v(" ˝ (1.3 or 1.6 cm) wide. You will need approximately:")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bb"
  }, [_vm._v("•")]), _vm._v("52˝ (1.3 m) of ribbon to wrap a 4˝ (10.2 cm) hoop")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bb"
  }, [_vm._v("•")]), _vm._v("68˝ (1.7 m) for a 5˝ (12.7 cm) hoop")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bb"
  }, [_vm._v("•")]), _vm._v("75˝ (1.9 m) for a 6˝ (15.2 cm) hoop")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bb"
  }, [_vm._v("•")]), _vm._v("115˝ (2.9 m) for an 8˝ (20.3 cm) hoop")]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg17_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Instead of ribbon, you can wrap the outer hoop with yarn, lace trim, or strips of fabric. Try painting the outer hoop with acrylics, wood stain, or watercolors. Write a favorite quote along the edge of the hoop with a permanent pen or doodle on some vines. Glue sequins, buttons or jewels to the edge of the hoop. If you want to get extra fancy, try attaching a ribbon or bow to the top screw of the hoop for hanging, or try hanging tassels, loose ribbons, trims, pom-poms, or charms from the bottom.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("Other Finishing Methods")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Instead of framing your embroidery art in a hoop, you can put it in a standard picture frame. Because I designed most of the patterns in this book to fit in round hoops, they will fit best in a square frame that is 2˝–3˝ (5.1–7.6 cm) larger than your embroidered piece. Measure and hem the edges around your design to create a square. You can hem the edges with a sewing machine, or hand sew them with a simple running stitch. Cut a piece of matte board to fit the frame and attach the embroidery with double sided tape or a small amount of white craft glue to the board. Fit the board into the frame.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("You can also create a simple wallhanging by hemming the edges of your fabric, leaving the top edge 4˝ (10.2 cm) longer than you want your hanging to be. Fold the top 2˝ (5.1 cm) down and sew to make a tube (like the curtain rod pocket at the top of a curtain) and slide a 1˝–1¼˝ (2.5–3.2 cm) dowel rod into the opening. Place a wooden cap on each end of the dowel. To hang the piece, tie a ribbon or string to the dowel ends. You may choose to embellish the bottom of your fabric with a trim or tassels. See Embellished Toile Pillow, Step 3.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("For a very easy and quick way to hang your embroidery, simply hang the piece, raw edges and all, up on the wall with pins or washi tape. This is a fun way to create an embroidery gallery wall that lets you easily remove or swap pieces whenever you want.")]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg19_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "c6"
    }
  }, [_vm._v("STITCH LIBRARY")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Now that you’ve learned all about the tools and techniques used in embroidery, you’re ready to start stitching. Here are some easy stitches to learn and use to create your embroidery artwork.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("Basic Stitches")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Outline stitches are the base of almost any design. You’ll use these to “draw” on the fabric, following the lines of the design, or design lines. Whenever you make outline stitches, it’s most important that the fabric you’re working on is taut so that your lines are not pulled out of shape. These stitches are the foundation of your design, so it’s important to start with quality work.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "h3a"
  }, [_vm._v("STRAIGHT STITCH")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The straight stitch is the most basic embroidery stitch. Just pull your needle through from the back at A. Move the needle forward along the design line, and then return it to the back of the fabric at B. Straight stitches can be any length, from a tiny dot to a ¼˝ (6 mm) long line.")]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg20_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_c('i', [_vm._v("Running Stitch")])]), _vm._v(" Several straight stitches in a row form the running stitch. They can be worked on a straight or curved design line. Usually, the individual stitches are the same length, and the distance between each stitch is the same.")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "h3a"
  }, [_vm._v("BACK STITCH")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The back stitch is a nice, clean outlining stitch. Start with a small stitch from A to B. Bring your needle back through the fabric at C, ahead of the first stitch and ending at A. Repeat to make each new back stitch, working backward on the surface and reinsert­ing the needle at the end of the previous stitch.")]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg20_2.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "h3a"
  }, [_vm._v("SPLIT STITCH")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Split stitches are quick and easy to make and create great outlines. On the front of the fabric, make a small stitch that’s a little longer than the desired finished stitch, from A to B. Bring the needle up through the center of the stitch, at C, to split the first stitch in half. Continue making stitches and splitting them, to form a line.")]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg21_1.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "h3a"
  }, [_vm._v("CHAIN STITCH")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The chain stitch works well not only for a thick outline but also as a decorative border. Pull the needle and floss through the fabric at A. Insert the needle back into the fabric at A, pulling the floss through to the back until you have a small loop about ⅛˝–¼˝ (3–6 mm) long on the front. Bring the needle back up through the fabric inside of the loop at B. Reinsert the needle at B, pulling the floss through to form a second small loop. Continue stitching loops to make a chain. When you finish a row, make a tiny stitch over the end of the last loop to hold it in place.")]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg21_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("To join a chain stitch circle, work chain stitches, as described above, around the circle until you’re one stitch short of the first stitch. Slide your needle and floss underneath the start of the first stitch, at C, and then insert it back into the fabric at the end of—and inside—the last finished loop to complete the circle.")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "h3a"
  }, [_vm._v("STEM STITCH")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The stem stitch is perfect for stitching curved lines or flower stems, which is how it got its name. Make a stitch from A to B, leaving the floss a little loose. Pull the needle to the front again at C, between A and B and just to one side. Pull the floss tight and continue to form a line of stitches.")]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg21_3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("Decorative Stitches")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Your creativity is best expressed with decorative stitches. While there’s a specific way to make each one, you get to decide the length and angle that determine its personality. A blanket stitch, for example, can be sharp and modern, or you can make each stitch looser—and space them closer together—for a more romantic effect. As you make the designs in this book, let your style shine through. Some of the described stitches are meant to be worked in a contin­uous line, while others are made independent of each other.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "h3a"
  }, [_vm._v("CROSS-STITCH")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Cross-stitches are easy to make and create interesting textures when they are stitched close together in rows, or spaced apart. Start with a small diagonal straight stitch from A to B. Make a second stitch from C to D. Rows look neater when the lines for each cross (X) overlap in the same direction. To make this easier, you can start by making a line of identical diagonal stitches, then go back and cross over them in the other direction.")]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg22_1.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "h3a"
  }, [_vm._v("BLANKET STITCH")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The blanket stitch makes a wonderful decorative border or edging. Starting on the design line, make a loose, diagonal stitch away from the line from A to B. Bring the needle up again on the design line at C, catching the floss under the needle and pulling it tight to the fabric. Make a new diagonal stitch to the right, and repeat, catching each stitch as you go.")]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg22_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("You can make the stitches even, or vary the distances between the stitches and the lengths of the diagonal stitches for a different look.")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "h3a"
  }, [_vm._v("FRENCH KNOT")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("French knots can be tricky at first, but they are well worth taking the time to learn. Individually, they make excellent dot accents, or you can fill an entire area with French knots to create solid color with an interesting texture. Bring the needle through the fabric at A. Wrap the floss around the tip of the needle in the direction shown and reinsert the needle at B, right next to A. Pull the floss tight and close to the fabric as you pull the needle back through. You can make larger French knots by wrapping the floss around the needle multiple times.")]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg23_1.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "h3a"
  }, [_vm._v("FLY STITCH")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The fly stitch is an interesting decorative accent stitch and also makes cute flowers. Pair it with a satin stitch or French knots to form the buds. Make a loose horizontal stitch from A to B. Press the loop flat to one side with your finger. Bring the needle back up at C, in the center of and below the first stitch. Return the needle at D, securing the first stitch to the fabric.")]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg23_2.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "h3a"
  }, [_vm._v("LAZY DAISY STITCH")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The lazy daisy stitch is the perfect way to make flower petals and leaves. You can use satin stitches or French knots to make the flower centers. Bring your needle and floss through the fabric at A, and insert the needle back down at A to leave a small loop. Now bring your needle back through the fabric inside the loop at B and back down at C, catching the loop at the top and securing it to the fabric. Repeat this stitch in a circle to make a daisy.")]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg23_3.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "h3a"
  }, [_vm._v("SCALLOP STITCH")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The scallop stitch is a cousin to the lazy daisy and fly stitch and is made with the same basic technique. Make a loose stitch on the design line from A to B. Press the stitch flat to one side of the line with your finger so that the center of the top is the desired depth of the finished scallop. Bring the needle to the front of the fabric at C, inside the loop. Insert the needle at the outside of the stitch, at D, to hold it in place. Scallop stitches are great for making flowers or leaves. For a pretty border, stitch several in a row.")]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg24_1.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "h3a"
  }, [_vm._v("SATIN STITCH")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Satin stitches are a lovely way to fill in small areas with smooth, solid color. Make a straight stitch from A to B. Make a second stitch right next to the first one from C to D. Always bring your needle up on one side and down on the other for best results. If you have trouble keeping the edges of your area even, first outline the shape with a tight back stitch and make your satin stitches over the top. For an extra smooth area of satin stitches, untwist and separate the strands of floss first before threading your needle and stitching.")]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg24_2.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "h3a"
  }, [_vm._v("LONG AND SHORT STITCH")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The long and short stitch is used to cover large areas with solid or blended color. Start the first row by making a stitch from A to B. Next, make another stitch right next to the first one from C to D, only half as long. Make another long stitch, then a short one, and continue alternating between the 2 stitches to form the first row. Only the first row has both long and short stitches; the rest of the stitches will all be the same length. For the second row, make stitches just below the first row of stitches, filling in any spaces. Unless you’re stitching a perfect square of long and short stitches, they probably won’t all be perfectly uniform, and that is just fine. Add a stitch here and there to fill in any gaps as you go along. Just keep all your stitches going in the same direction, and you’ll have an evenly filled area when you’re finished.")]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg25_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Thread painting” is a variation of the long and short stitch and can be used to create beautiful, lush pictures with embroidery. When painting with thread, use the long and short stitch instructions as a starting point, but feel free to add or change colors, lengths and spacing of stitches as needed. Try gradations of colors to add dimension, or angling stitches to follow the shapes in the image you’re stitching.")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "h3a"
  }, [_vm._v("BULLION KNOT")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Bullion knots are similar to French knots. Start by bringing the needle out of the fabric at A. Make a stitch about ¼˝ (6 mm) wide from B to C (close to A). This will be the length of your bullion knot. While the end of the needle is sticking out of the fabric, wrap floss around the needle 5 to 7 times. Now slowly pull the needle and floss through the wraps while you hold them down to the fabric with your thumb. Reinsert the needle at B, pulling the coil of wraps tightly to the fabric. Stitch several bullion knots pointing out from a center point to make a flower or star shape, or stitch several curving around each other to make Bullion Roses.")]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg25_2.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "h3a"
  }, [_vm._v("COUCHING")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Couching involves stitching a loose strand of floss to the top of your fabric. Simply arrange the floss on the surface of the fabric, and with a second piece of floss or thread, make tiny stab stitches over and back through the fabric to hold it down. Make your stitches about ¼˝ (0.6 cm) apart. Use thread of the same color or 1 or 2 threads of floss to hide the stab stitches or a contrasting color and more threads if you want the stitches to stand out. You can use couching to attach pieces of yarn, ribbon, rickrack, or cords to your fabric as well.")]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg26_1.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "h3a"
  }, [_vm._v("FISHBONE STITCH")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The fishbone stitch is a form of cross-stitch that is perfect for making leaves. Start by drawing a simple leaf shape pattern to follow, pointed at one or both ends. Make a straight stitch from the top to the bottom of the shape. Now bring your needle and floss up just to the left side of the top at A, moving downward and across the center line, just to the right side of it at B, which is a bit more than halfway between the top and the bottom. Then bring the needle and floss up again just to the right of the top point at C, and back down and across to the left side at D. Bring the needle and floss up again just below the A stitch at E, following your pattern and continue the crossing stitches all the way down until the leaf is complete.")]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg26_2.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "h3a"
  }, [_vm._v("WOVEN SPIDER’S WHEEL")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The woven spider’s wheel is perfect for stitching bold circles and flowers. Start by making an odd number of straight stitches (usually 5 or 7) in a star shape out from a center point. Make the spokes each about ¼˝ (6 mm) long, or half as wide as you want your wheel to be. Bring your needle and floss up at the center between 2 spokes and slide them over 1 stitch and under the next, round and round the circle on the surface of the fabric, until you reach the outer ends of the spokes. You can use fewer rounds for a flatter circle, or pack in many rounds for a puffy flower.")]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg26_3.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "h3a"
  }, [_vm._v("WHIPPED SPIDER’S WHEEL")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The whipped spider’s wheel is similar to the woven version, except you’ll whip your stitches over each spoke. Start by making an odd number of straight stitches (usually 5 or 7) in a star shape out from a center point, just like you would for a woven spider’s wheel. Then bring your needle and floss up between 2 spokes. Next take your needle backward over 1 spoke and under the next 2 spokes. Repeat all around the circle.")]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg27_1.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "h3a"
  }, [_vm._v("BUTTONHOLE WHEEL")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A buttonhole wheel is stitched like a blanket stitch. Bring the needle up at A, and make a loose stitch from A to B, your center point. Catch the stitch under your needle at C, pulling it tight to the fabric. It will help to first draw a circle with a pencil or a nonpermanent fabric marker to create an outline that you can follow.")]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg27_2.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "h3a"
  }, [_vm._v("WEAVING")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("You can create a small area of woven floss on your embroidery art with this technique. Begin by making an odd number of straight stitches (usually 5 or 7) in a row, each about 1˝ (2.5 cm) long. Bring your needle and floss up at one of the top corners and slide them over 1 stitch and under the next, across the row. When you reach the end of the row, loop the needle and floss around it (don’t pull it too tightly) to reverse the direction that you’re stitching. Repeat weaving over and then under the stitches across the next row. Continue weaving back and forth until the straight stitches are covered. You can experiment with making larger woven areas or ones in different shapes.")]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg27_3.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "h3a"
  }, [_vm._v("SHISHA STITCH")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Shisha embroidery originated in ancient Persia and is tradi­tionally used to attach tiny mirrors to clothing and wallhangings. It can also be used to attach any flat object, such as stones, shells, coins, bottle caps, sequins, or guitar picks. To attach an object using the shisha stitch, hold it flat against the fabric and make 4 straight stitches across the object vertically and horizontally to hold it in place. Next, stitch 4 more straight stitches across diagonally to form a star shape. Keep these stitches tight and not too close to the edge of the object.")]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg28_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Now bring the needle and floss up at A and under the straight stitches from the center at B. Pass the tip of the needle over the floss, making a tiny blanket stitch.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Repeat this step, then make another tiny stitch along the outside edge, catching the previous stitch and a tiny bit of fabric at C. Pass the needle over the floss again and pull it tight to the fabric. Repeat this stitch all the way around the object.")])]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "c7"
    }
  }, [_vm._v("SEWING ESSENTIALS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A few of the projects in this book require some hand sewing to complete. Here are some easy techniques you can use for these and other hand-sewing projects.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("Appliqué")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Stitching a piece of contrasting colored or patterned fabric onto your embroidery fabric surface adds color and interest to your work. You can cut felt or other fabric pieces out using regular scissors, or pinking shears for a decorative edge, and stitch them directly onto the background fabric using the stab stitch. If you’d rather hide the raw fabric edge, use the appliqué stitch.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "h3a"
  }, [_vm._v("APPLIQUÉ STITCH")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("To hide fraying fabric edges, draw the shape onto a piece of appliqué fabric, and cut it out, leaving ¼˝ (6 mm) extra fabric beyond the lines. Fold and press the ¼˝ (6 mm) of the fabric edge to the back of the appliqué shape. Pin the shape in place on the embroidery fabric. Pull a knotted length of thread from the back of the embroidery fabric to the front at A, very near the edge, and through the appliqué. Insert the needle back through the embroidery fabric at B and bring the tip of the needle up again at C. Pull the thread tightly through, securing the fabrics together. Continue making even, equally spaced stitches around the perimeter of the appliqué.")]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg29_1.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "h2"
  }, [_vm._v("Embroidering with Beads")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Beads add fun, sparkly accents to your embroidery. It’s easy to stitch them on individually or in rows. Depending on the size of the beads you’re using, you may be able to use a sewing needle, or you may need to purchase some extra thin beading needles, which will fit through the holes of even the tiniest beads. Use thread or 1 of the 6 threads of embroidery floss in a color matching your bead. Sew beads on one at a time using a small straight stitch, or 3 or 4 small beads at a time using the back stitch to secure a few beads in each section.")]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg30_1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("Basic Sewing Stitches")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "h3a"
  }, [_vm._v("HIDDEN STITCH")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("For some projects, such as the Kid Art Play Pillow, you will need to sew the front and back pieces together inside out, and then turn it right side out through an unstitched opening for stuffing. After stuffing, use the nearly invisible hidden stitch to sew up the opening. First fold the extra fabric in along each side of the opening to match the seam on either side and pin the hole closed. Thread a needle with thread matching the color of the fabric and knot it at one end. Bring the needle and thread out through the fabric from the back at A and back down directly across the opening at B. Slide the needle along the inside of the fold and pull it back out at C, trapping the stitch inside. Reinsert the needle across from C at D, pulling the thread taut to close the opening and hide the stitches. Continue stitching back and forth along the hole, closing the seam. When you get to the end, make a tiny knot buried in the seam.")]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg30_2.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "h3a"
  }, [_vm._v("TOPSTITCH")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Topstitching is done by hand or machine after fabric pieces are sewn together and the project is turned right side out, or to hem a fabric edge. Just sew a line of small straight stitches close together through both layers of fabric. Topstitching is usually done close to and parallel with an edge.")]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg31_1.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "h3a"
  }, [_vm._v("WHIP STITCH")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Whip stitches are a great way to add a decorative touch while joining 2 pieces of fabric together along matched edges. You can also use it to hem the raw edge of a piece of fabric, or alone as a decorative stitch. Use matching thread to hide your stitches, or embroidery floss in a contrasting color to show them off.")]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg31_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Starting at the back, or between 2 pieces of fabric, bring your needle and floss through at A. Bring the needle over the edge of the fabric and reinsert it from the back at B.")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "h3a"
  }, [_vm._v("STAB STITCH")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The stab stitch is a variation of the running stitch using very tiny stitches. It’s most often used to attach a piece of fabric to a background fabric. Use thread matching the fabric or one thread from a strand of floss. Bring the needle up at A and down at B, ⅛˝ (3 mm) from the edge of the fabric. Continue stitching all around the edge.")]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg31_3.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cce4c6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/06_chapter01.vue
// module id = 69
// module chunks = 0